import MUIAvatar from '@mui/material/Avatar';

import { styled } from '@mui/material/styles';

function AvatarStyles(input) {
  const { theme } = input;
  const { palette } = theme;
  return {
    width: 56,
    height: 56,
    backgroundImage: `linear-gradient(147deg, ${palette.primary.light} 0%, ${palette.primary.dark} 74%)`,
  };
}

export const Avatar = styled(MUIAvatar)(AvatarStyles);
